module.exports = __webpack_public_path__ + "img/P14.0a9bf123.png";